// Password Generator Tool — strong random passwords in the browser (CSPRNG).
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const passwordGeneratorTool: Tool = {
  id: "password-generator",
  name: () => m.pw_tool_name(),
  description: () => m.pw_tool_description(),
  icon: "🔑",
  basePath: "/password-generator",
  status: "stable",
  tags: ["password", "security", "generator", "random"],
  pages: [
    {
      name: () => m.pw_nav_main(),
      path: "/password-generator",
      description: () => m.pw_nav_main_desc(),
      icon: "🔑",
    },
  ],
};
